import React from 'react';
import { useResponsive } from '@parsina/framework';
import CreditsWeb from './Credits.web.jsx';
import CreditsMobile from './Credits.mobile.jsx';

// اعتبار — two surfaces, one balance.
//
// The mobile surface is not the desktop page in a narrow column. The balance
// moves INTO the gradient header (§3.2 — on this screen the number that must
// never scroll away is the balance itself), the three-column rail becomes two
// collapsed sections at the foot, the date window is chosen from chips rather
// than from a dropdown, and the desktop's `PageHeader`/`KpiCard` are replaced by
// `MobileHeader`/`StatTiles` — §1.1's rule that layout, page anatomy and chrome
// are NOT shared.
//
// What IS shared is `Credits.shared.js`: the service vocabulary, the ledger
// parsing, the grouping and the KPI arithmetic. So the two surfaces can differ
// in shape and can never differ about what a row says or what «این ماه» adds
// up to. `TopUpSheet`, `GiftCodeCard` and `LowBalanceCard` are shared for the
// same reason — they are content, not chrome.
const CreditsScreen = () => {
  const { isMobile } = useResponsive();
  return isMobile ? <CreditsMobile /> : <CreditsWeb />;
};

export default CreditsScreen;
